export default __webpack_public_path__ + "static/media/JUnit_5.92bfa3ff.png";